import { Slot, SlotType } from '@frontend/slot/types';

/** Terminal SLOTs stay unlabeled on the layout; other SLOTs show their number. */
export const slotLayoutDisplayNumber = (slot: Pick<Slot, 'type' | 'number'> | null | undefined): string =>
    !slot || slot.type === SlotType.TERMINAL ? '' : (slot.number ?? '');
